import { schema } from 'normalizr';
import collectionAttributeSchema from './collectionAttribute';
import collectionCategorySchema from './collectionCategory';

const collectionSchema = new schema.Entity('collections', {
  categories: [collectionCategorySchema],
  attributes: [collectionAttributeSchema],
});

export default collectionSchema;
